import s from './NumericInput.module.css';

export default function NumericInput({ label, unit, id, className = '', ...rest }) {
  const inputId = id || (label ? `num-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <label className={s.field} htmlFor={inputId}>
      <span className={s.row}>
        {label && <span className={s.label}>{label}</span>}
        {unit && <span className={s.unit}>{unit}</span>}
      </span>
      <input
        id={inputId}
        type="number"
        inputMode="decimal"
        className={`${s.input} ${className}`.trim()}
        {...rest}
      />
    </label>
  );
}
